import Loading from 'components/Loading';
import styled from 'styled-components';
import RenderAfterNavermapsLoaded from 'utils/RenderAfterNavermapsLoaded';
import ComplexStandardPriceMap from './ComplexStandardPriceMap';

function ComplexStandardPriceMapHome() {
  return (
    <>
      <Container>
        <RenderAfterNavermapsLoaded
          ncpClientId={`${process.env.REACT_APP_NAVER_MAP_KEY}`}
          error={<Loading />}
          loading={<Loading />}
        >
          <ComplexStandardPriceMap />
        </RenderAfterNavermapsLoaded>
      </Container>
    </>
  );
}

export default ComplexStandardPriceMapHome;

const Container = styled.div`
  width: 100vw;
  height: 100vh;
`;
